<template>
  <div class="thumbnail-container">
    <div class="image-container">
      <BbIcon name="slides" class="default-thumb" />
    </div>
  </div>
  <div class="footnote-details">
    <EditableReferenceField
      :value="customTitle"
      :isEditing="isEditableTitle"
      :editable="displayIcon"
      :ellipsis="false"
      @cancel="$emit('cancel')"
      @set-editable="$emit('set-editable')"
      @update="$emit('update', $event)"
      @delete="$emit('delete')"
    />
  </div>
</template>
<script>
import { ref, watch } from 'vue';

import EditableReferenceField from '~/components/conversation/authoring/references/EditableReferenceField.vue';

export default {
  components: { EditableReferenceField },
  emits: ['update', 'cancel', 'set-editable', 'delete'],
  props: {
    title: {
      type: String,
      default: '',
    },
    isEditableTitle: {
      type: Boolean,
      default: false,
    },
    displayIcon: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const customTitle = ref(props.title);

    watch(
      () => props.title,
      (newValue) => {
        customTitle.value = newValue || props.title;
      },
    );

    return { customTitle };
  },
};
</script>
